import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';

import { IconName } from '../../../../icons-container/icons.type';
import { RtComponentShape } from '../../../../props/component-shape';
import { IconComponent, IconSize } from '../../../icon/icon.component';
import { BaseButtonDirective } from '../../base-button';
import {
  ExtendableButton,
  RtButtonColorContextVariant,
  RtButtonVariant,
  RtIconButtonVariant,
  RtInfoboxButtonVariant,
} from '../../button.types';

@Component({
  standalone: true,
  selector: `rt-icon-button, a[rt-icon-button]`,
  templateUrl: './icon-button.component.html',
  styleUrls: [
    './../../styles/base.less',
    './../../styles/context.less',
    './icon-button.component.less',
    '../../directives/button-loading/button-loading.directive.less',
  ],
  host: {
    '[class]': 'shape',
  },
  // eslint-disable-next-line
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: ExtendableButton, useExisting: IconButtonComponent }],
  imports: [IconComponent],
})
export class IconButtonComponent extends BaseButtonDirective implements ExtendableButton {
  @ViewChild('primarySlot', { static: true, read: ViewContainerRef })
  public primarySlot: ViewContainerRef;

  @ViewChild('secondarySlot', { static: true, read: ViewContainerRef })
  public secondarySlot: ViewContainerRef;

  @Input() public iconName: IconName;
  @Input() public iconSize: IconSize = 'small';
  @Input() public shape: Extract<RtComponentShape, 'square' | 'round'> = 'square';
  @Input() public variant:
    | RtButtonVariant
    | RtIconButtonVariant
    | RtInfoboxButtonVariant
    | RtButtonColorContextVariant;
}
